module.exports = __webpack_public_path__ + "img/smile.6e08065.png";